import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateInputFillMode, DateInputRounded } from '@progress/kendo-angular-dateinputs';
import { isEqual } from 'lodash';

@Component({
  selector: 'log-list-filter',
  templateUrl: './log-list-filter.component.html',
  styleUrls: ['./log-list-filter.component.scss'],
  standalone: false,
})
export class LogListFilterComponent implements OnInit {
  public startDate: Date;
  public endDate: Date;
  public constructor(private _activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    if (this.pageFilter.startDate) {
      this.startDate = new Date(this.pageFilter.startDate);
    }

    if (this.pageFilter.endDate) {
      this.endDate = new Date(this.pageFilter.endDate);
    }
  }

  public pageFilter: app.models.GetPagedAgentSyncLogFilterModel;
  public initialFilterState: app.models.GetPagedAgentSyncLogFilterModel;
  public fillModeOutline: DateInputFillMode = 'outline';
  public roundedLarge: DateInputRounded = 'large';

  public closeHandler() {
    this._activeModal.close(false);
  }

  public resetHandler() {
    this.pageFilter.startDate = null;
    this.pageFilter.endDate = null;
    this.pageFilter.searchFieldText = '';
    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : 0);
  }

  public applyHandler() {
    if (this.startDate) this.pageFilter.startDate = this.startDate;
    if (this.endDate) this.pageFilter.endDate = this.endDate;
    let filterCount = 0;
    if (this.pageFilter.startDate != null) filterCount++;
    if (this.pageFilter.endDate != null) filterCount++;
    this._activeModal.close(isEqual(this.pageFilter, this.initialFilterState) ? false : filterCount);
  }
}
